<template>
    <div>
        <project-list :projects="projects" type="normal"></project-list>
    </div>
</template>
<script>
export default {
  props: ["data"],
  computed: {
    projects() {
      return this.data.projects;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/umbrella_project/ProjectList.vue